<template>
    <div v-if="status.statisticSummary" class="row">
        <div class="col-md-3 mb-4">
            <div class="card shadow h-100 mb-0">
                <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h6 class="text-muted mb-0">Total Assets</h6>
                        <span class="avatar-title rounded bg-soft-primary text-primary summary-icon">
                            <i class="mdi mdi-home-city-outline font-size-24"></i>
                        </span>
                    </div>
                    <h3 class="font-weight-bold mb-2">{{ formatNumber(data.totalAssets, 0) }}</h3>
                    <small class="text-muted">Properties in the asset portfolio</small>
                </div>
            </div>
        </div>
        <div class="col-md-3 mb-4">
            <div class="card shadow h-100 mb-0">
                <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h6 class="text-muted mb-0">Asset Value</h6>
                        <span class="avatar-title rounded bg-soft-warning text-warning summary-icon">
                            <i class="mdi mdi-finance font-size-24"></i>
                        </span>
                    </div>
                    <small class="text-muted">Total NBV</small>
                    <h4 class="font-weight-bold mt-1 mb-3">{{ formatNumber(data.nbvValue) }}</h4>
                    <div class="border-top pt-2">
                        <small class="text-muted">Total Purchase Value</small>
                        <h5 class="font-weight-bold mt-1 mb-0">{{ formatNumber(data.purchaseValueTotal) }}</h5>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3 mb-4">
            <div class="card shadow h-100 mb-0">
                <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h6 class="text-muted mb-0">Total Land Size</h6>
                        <span class="avatar-title rounded bg-soft-success text-success summary-icon">
                            <i class="mdi mdi-map-outline font-size-24"></i>
                        </span>
                    </div>
                    <h4 class="font-weight-bold mb-1">{{ formatNumber(data.landSize) }}</h4>
                    <small class="text-muted">{{ data.propertyAreaUnit ? data.propertyAreaUnit.name : '--' }}</small>
                    <div class="d-flex justify-content-between mt-3 mb-2 small">
                        <span class="text-muted">Utilized</span>
                        <span>{{ formatNumber(data.utilizeLandSize) }}</span>
                    </div>
                    <b-progress :value="Number(data.utilizeLandSizePercentage) || 0" :max="100" variant="success" height="6px" />
                    <div class="text-success small mt-2">{{ formatNumber(data.utilizeLandSizePercentage) }}% utilized</div>
                </div>
            </div>
        </div>
        <div class="col-md-3 mb-4">
            <div class="card shadow h-100 mb-0">
                <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h6 class="text-muted mb-0">Total Building Size</h6>
                        <span class="avatar-title rounded bg-soft-info text-info summary-icon">
                            <i class="mdi mdi-office-building font-size-24"></i>
                        </span>
                    </div>
                    <h4 class="font-weight-bold mb-1">{{ formatNumber(data.buildingSize) }}</h4>
                    <small class="text-muted">{{ data.propertyAreaUnit ? data.propertyAreaUnit.name : '--' }}</small>
                    <div class="d-flex justify-content-between mt-3 mb-2 small">
                        <span class="text-muted">Utilized</span>
                        <span>{{ formatNumber(data.utilizeBuildingSize) }}</span>
                    </div>
                    <b-progress :value="Number(data.utilizeBuildingPercentage) || 0" :max="100" variant="info" height="6px" />
                    <div class="text-info small mt-2">{{ formatNumber(data.utilizeBuildingPercentage) }}% utilized</div>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="d-flex justify-content-center align-items-center m-5 p-5">
        <b-spinner variant="info" role="status"></b-spinner>
    </div>
</template>
<script>
import { mapState } from "vuex";
import { propertyAssetMethods } from "@/state/api";
import { PROPERTY_ASSET_MODULE } from "@/state/api/propertyAsset.state";

export default {
    created() {
        this.getPropertyAssetStatisticSummary();
    },
    methods: {
        ...propertyAssetMethods,
        formatNumber(value, decimals = 2) {
            return value == null ? '--' : Number(value).toLocaleString('en-MY', {
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals,
            });
        },
    },
    computed: {
        ...mapState(PROPERTY_ASSET_MODULE, ['status']),
        data() {
            return this.$store.state.api.propertyAsset.statisticSummary || {};
        },
    },
}
</script>
<style scoped>
.summary-icon {
    width: 42px;
    height: 42px;
    flex-shrink: 0;
}
</style>
